const redirectToErrorPage = () => {
    if (!window.location.pathname.startsWith('/server-error')) {
        window.location.href = '/server-error';
    }
};

export default { redirectToErrorPage };
